import * as React from 'react';
import { withRouter } from 'react-router-dom';
import Async from 'react-select/lib/Async';
import { connect } from 'react-redux';
import notify from '../../shared/feedback/notifications';
import { Button } from 'react-bootstrap';
import { impersonate } from '../../actions/userActions';
import UserApi from '../../api/UserApi';
import { Translate } from '../../shared/LanguageService';
import * as util from '../../shared/Utilities';

interface IImpersonateFormProps {
    onUserImpersonated(): void;
    onClose(): void;
    actions: { impersonate(id: number): Promise<any> };
    history: any;
}

class ImpersonateForm extends React.Component<IImpersonateFormProps, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = { impersonation: false };
        this.impersonate = this.impersonate.bind(this);
        this.closeDropDown = this.closeDropDown.bind(this);
    }

    impersonate(selectedItem: { value: string; label: string }) {
        if (selectedItem) {
            let userId = parseInt(selectedItem.value);
            this.props.history.push('/');
            this.props.actions
                .impersonate(userId)
                .then(() => {
                    notify.success(Translate('impersonation/notification/now-impersonating'));
                    this.props.onUserImpersonated();
                })
                .catch((error: any) => {
                    notify.failure(Translate('impersonation/notification/impersonation-failed'));
                });
        }
    }

    loadUsersForImpersonation(input, callback) {
        UserApi.customers(input).then((result) => {
            callback(
                result.customers.map((dto) => {
                    return {
                        label: `${dto.firm} - ${dto.label}`,
                        value: dto.value
                    };
                })
            );
        });
    }

    closeDropDown() {
        this.props.onClose();
    }

    render() {
        return (
            <div className="customer-impersonation-form">
                <Async
                    className="Select"
                    classNamePrefix="impersonate"
                    placeholder={Translate('header/nav/impersonate-customer')}
                    searchPromptText=""
                    clearable={true}
                    autoFocus={true}
                    ignoreAccents={false}
                    onChange={(e: { value: string; label: string }) => this.impersonate(e)}
                    loadOptions={util.debounce(this.loadUsersForImpersonation, 350)}
                    noOptionsMessage={() => null}
                />
                <Button onClick={this.closeDropDown} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </Button>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {};
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            impersonate: (id: number) => dispatch(impersonate(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImpersonateForm));
